export const FORCE_UPDATE_AFTER_REMIND_COUNT = 5;
export const REMIND_LATER_DURATION_MS = 24 * 60 * 60 * 1000;

export function getRemindLaterCount({
  version,
  count,
}: {
  version: string | null | undefined;
  count: Record<string, number>;
}): number {
  if (!version) {
    return 0;
  }
  return count[version] ?? 0;
}

export function isForceUpdateRequired({
  version,
  count,
}: {
  version: string | null | undefined;
  count: Record<string, number>;
}): boolean {
  return (
    getRemindLaterCount({ version, count }) >= FORCE_UPDATE_AFTER_REMIND_COUNT
  );
}

export function isUpdatePendingState(
  updateState: string,
): updateState is
  | 'available'
  | 'preparing-download'
  | 'downloading'
  | 'downloaded' {
  return (
    updateState === 'available' ||
    updateState === 'preparing-download' ||
    updateState === 'downloading' ||
    updateState === 'downloaded'
  );
}
